// extracted by mini-css-extract-plugin
module.exports = {"main-container":"NewPromo_main-container__3Y_bl","left-container":"NewPromo_left-container__10Zhz","right-container":"NewPromo_right-container__2zU_e"};